import React from 'react';

interface IOwnProps {
    value?: string,
    modifierClass?: string;
    name: string;
    label: string;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    invalid?: boolean;
    notice?: string;
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

type Props = IOwnProps;

class FormTextArea extends React.Component<Props, {}> {
    private input = React.createRef<HTMLTextAreaElement>();

    public focus = () => {
        this.input.current!.focus();
    }

    public render() {
        return <div className="form__section__inner">
            <div className={'form__field form__field--textarea'.cAppend(this.props.modifierClass)
                .cAppend(this.props.disabled, 'is-disabled')
                .cAppend(this.props.required, 'is-required')
                .cAppend(this.props.invalid, 'is-invalid')
            }>
                <label htmlFor={this.props.name} className="form__label">
                    <span className="form__label__text">{this.props.label}{this.props.required &&
                        <React.Fragment>&nbsp;&nbsp;<strong>&#10033;</strong></React.Fragment>}</span>
                </label>
                <textarea name={this.props.name} id={this.props.name} className="form__item" placeholder={this.props.placeholder} disabled={this.props.disabled} onChange={this.handleChange} ref={this.input} value={this.props.value} />
                {this.props.notice &&
                    <span className="form__notice">{this.props.notice}</span>
                }
            </div>
        </div>;
    }

    private handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.persist();

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }
}

export default FormTextArea;